import { useEffect, useState } from 'react';
import * as ep from '../api/endpoints';
import { disablePush, enablePush, pushState, type PushState } from '../lib/push';
import { messageOf } from '../lib/errors';
import { Icon } from './Icon';

/** Bu cihazda telefon bildirimlerini açma/kapatma. */
export function PushToggle({ compact = false }: { compact?: boolean }) {
  const [state, setState] = useState<PushState | null>(null);
  const [busy, setBusy] = useState(false);
  const [msg, setMsg] = useState<string | null>(null);
  useEffect(() => { void pushState().then(setState).catch(() => setState('unsupported')); }, []);
  if (state === null) return null;
  if (compact && state === 'on') return null;

  async function turnOn() {
    setBusy(true); setMsg(null);
    try {
      const ok = await enablePush();
      setState(await pushState());
      setMsg(ok ? 'Bildirimler bu cihazda açıldı.' : 'İzin verilmedi. Tarayıcı ayarlarından bildirime izin verebilirsiniz.');
    } catch (e) { setMsg(messageOf(e)); } finally { setBusy(false); }
  }
  async function turnOff() {
    setBusy(true); setMsg(null);
    try { await disablePush(); setState(await pushState()); } catch (e) { setMsg(messageOf(e)); } finally { setBusy(false); }
  }
  async function test() {
    setBusy(true); setMsg(null);
    try {
      const r = await ep.pushTest();
      setMsg(r.devices ? 'Deneme bildirimi gönderildi; birkaç saniye içinde gelir.' : 'Bu hesapta bildirime açık cihaz yok.');
    } catch (e) { setMsg(messageOf(e)); } finally { setBusy(false); }
  }

  return (
    <div className={`alert ${state === 'on' ? 'ok' : 'info'} small push-toggle`}>
      <Icon name="bell" size={18} />
      <div style={{ flex: 1 }}>
        {state === 'on' && <>Telefon bildirimleri bu cihazda <strong>açık</strong>.</>}
        {state === 'off' && <>Ödeme hatırlatmalarını telefonunuza bildirim olarak almak için bildirimleri açın.</>}
        {state === 'denied' && <>Bildirim izni kapalı. Telefonun ayarlarından bu uygulamaya (ya da tarayıcıya) bildirim izni verin.</>}
        {state === 'needs-install' && <>iPhone'da bildirim için önce uygulamayı ana ekrana ekleyin (Paylaş → Ana Ekrana Ekle), sonra oradan açın.</>}
        {state === 'unsupported' && <>Bu tarayıcı telefon bildirimini desteklemiyor. Bildirimler uygulamadaki “Bildirimler” sayfasında görünür.</>}
        {msg && <div style={{ marginTop: 4 }}>{msg}</div>}
      </div>
      {state === 'off' && <button className="btn small primary" disabled={busy} onClick={() => void turnOn()}>Bildirimleri aç</button>}
      {state === 'on' && !compact && (
        <span className="row" style={{ gap: 6 }}>
          <button className="btn small" disabled={busy} onClick={() => void test()}>Dene</button>
          <button className="btn small" disabled={busy} onClick={() => void turnOff()}>Kapat</button>
        </span>
      )}
    </div>
  );
}
